import { scenarios } from "@/mocks/home";

export default function Scenarios() {
  return (
    <section id="scenes" className="w-full py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 text-xs md:text-sm font-medium text-accent-700">
            <i className="ri-live-line"></i>
            使用场景
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            不同场景，选不同的观看方式
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            在线观看和缓存下载并不是二选一。根据所处环境选择合适的清晰度与观看方式，
            体验会顺畅很多。下面列出几种最常遇到的情形。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {scenarios.map((item) => (
            <article
              key={item.id}
              className="group relative w-full h-[240px] md:h-[280px] rounded-lg overflow-hidden"
            >
              <img
                src={item.image}
                alt={`${item.title} 场景示意图`}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/45 to-foreground-950/10"></div>
              <div className="relative z-10 h-full p-5 md:p-6 flex flex-col justify-end">
                <span className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 mb-3">
                  <i className={`${item.icon} text-xl`}></i>
                </span>
                <h3 className="font-heading text-lg md:text-xl font-bold text-background-50">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-background-100/85 leading-relaxed max-w-lg">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}